export const ArrowOut = () => (
    <svg width="31" height="26" viewBox="0 0 31 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M30.1251 12.1249L18.8751 0.874939C18.3959 0.395772 17.6042 0.395772 17.1042 0.874939C16.6251 1.35411 16.6251 2.14577 17.1042 2.64577L26.2293 11.7499L1.54175 11.7499C0.854248 11.7499 0.291748 12.3124 0.291748 12.9999C0.291748 13.6874 0.854248 14.2499 1.54175 14.2499L26.2293 14.2499L17.1042 23.3749C16.6251 23.8541 16.6251 24.6458 17.1042 25.1458C17.3542 25.3958 17.6667 25.5208 17.9792 25.5208C18.2917 25.5208 18.6251 25.3958 18.8542 25.1458L30.1043 13.8958C30.6251 13.3958 30.6251 12.6041 30.1251 12.1249Z"
            fill="#A4343A"
        />
    </svg>
);
